import React, { useState, FC } from 'react';

import Icon from '@material-ui/core/Icon';
import Paper from '@material-ui/core/Paper';
import CopyToClipboard from 'react-copy-to-clipboard';
import { getEventURL } from '../../../../../contrib/Utils/getEventURL';

interface IProps {
  eventId: string;
}

export const UniqueLinkToEventContainer: FC<IProps> = props => {
  const { eventId } = props;
  const [copyStatusLabel, setCopySuccess] = useState<'Copy' | 'Copied'>('Copy');

  const onCopy = (): void => {
    setCopySuccess('Copied');

    setTimeout(() => {
      setCopySuccess('Copy');
    }, 5 * 1000);
  };

  const copyText = getEventURL(eventId);

  return (
    <Paper elevation={1} className="paper copy-link-widget">
      <h3 className="copy-link-widget__title">UNIQUE LINK TO EVENT</h3>

      <p>
        After the event is live this link will allow any player qualifed to play in this event
        access to register.
      </p>

      <div className="buttons copy">
        <CopyToClipboard text={copyText} onCopy={onCopy}>
          <div className="container">
            <div className="text">
              <span>{copyText}</span>
            </div>

            <div className="cta">
              <span className="message">{copyStatusLabel}</span>

              <Icon>filter_none</Icon>
            </div>
          </div>
        </CopyToClipboard>
      </div>
    </Paper>
  );
};
